import { z } from "zod";
import { Sha256HexSchema } from "./primitives.js";

/**
 * Spec: the source input to the pipeline. OpenAPI 3.x is the v0 must-have; GraphQL is
 * carried as a stable interface signature for v1 (ADR-0002).
 */
export const SpecSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  source: z.discriminatedUnion("kind", [
    z.object({
      kind: z.literal("openapi"),
      version: z.string().regex(/^3\./, "OpenAPI 3.x required"),
      document: z.unknown()
    }),
    z.object({
      kind: z.literal("graphql"),
      sdl: z.string().min(1)
    })
  ]),
  digest: Sha256HexSchema,
  ingestedAt: z.string().datetime({ offset: true })
});
export type Spec = z.infer<typeof SpecSchema>;
